var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.header.classes},[(_vm.value)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g({staticClass:"mx-2",staticStyle:{"cursor":"default"},attrs:{"fab":"","dark":"","x-small":"","color":_vm.value.meta.color}},on))]}}],null,false,58499272)},[_c('span',[_vm._v(_vm._s(_vm.value.name))])]):_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("mdi-minus")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }